import { render, staticRenderFns } from "./CustomSelectedOption.vue?vue&type=template&id=64c6817f&scoped=true"
import script from "./CustomSelectedOption.vue?vue&type=script&lang=js"
export * from "./CustomSelectedOption.vue?vue&type=script&lang=js"
import style0 from "./CustomSelectedOption.vue?vue&type=style&index=0&id=64c6817f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c6817f",
  null
  
)

export default component.exports